type FullscreenDocument = Document & {
  webkitFullscreenElement?: Element | null;
  webkitExitFullscreen?: () => Promise<void> | void;
};

type FullscreenElement = HTMLElement & {
  webkitRequestFullscreen?: () => Promise<void> | void;
};

export function getFullscreenElement(): Element | null {
  if (typeof document === "undefined") return null;
  const doc = document as FullscreenDocument;
  return doc.fullscreenElement ?? doc.webkitFullscreenElement ?? null;
}

export function isElementFullscreen(el: HTMLElement | null): boolean {
  if (!el) return false;
  const fs = getFullscreenElement();
  return fs === el;
}

export async function requestElementFullscreen(el: HTMLElement): Promise<void> {
  if (el.requestFullscreen) {
    await el.requestFullscreen();
    return;
  }
  const webkit = (el as FullscreenElement).webkitRequestFullscreen;
  if (webkit) await webkit.call(el);
}

export async function exitDocumentFullscreen(): Promise<void> {
  const doc = document as FullscreenDocument;
  if (doc.fullscreenElement && doc.exitFullscreen) {
    await doc.exitFullscreen();
    return;
  }
  if (doc.webkitFullscreenElement && doc.webkitExitFullscreen) {
    await doc.webkitExitFullscreen();
  }
}

export function subscribeFullscreenChange(onChange: () => void): () => void {
  const events = ["fullscreenchange", "webkitfullscreenchange"] as const;
  for (const event of events) {
    document.addEventListener(event, onChange);
  }
  return () => {
    for (const event of events) {
      document.removeEventListener(event, onChange);
    }
  };
}

export function standalonePreviewScroller(wrap: HTMLElement): HTMLElement | null {
  const page = wrap.closest(".preview-standalone-page");
  if (!page) return null;
  const viewer = wrap.querySelector<HTMLElement>(".document-viewer, .pdf-viewer, .image-preview__viewport");
  if (viewer) return viewer;
  return page.querySelector<HTMLElement>(".preview-standalone__main");
}
